@if (icon) {
<href [link]="iconLink || ''"
      class="_icon"
      [ngClass]="'m-r-' + offset">
    <i [ngClass]="'icon-' + icon"
       [lineHeightBy]="textClass"
       class="_iconel flex flex-middle"></i>
</href>
}

<span [ngClass]="[textClass]"
      class="inline-block va-m _copy">
    <ng-content></ng-content>
</span>
